"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllExplores = exports.getAllLookmlModels = void 0;
const lookmlModelDto_1 = require("../../dtos/lookmlModelDto");
const internalAxios_1 = require("./internalAxios");
const getAllLookmlModels = async () => {
    const { data } = await internalAxios_1.internalAxios.get('api/explore/all');
    return data.map((model) => new lookmlModelDto_1.LookmlModelDto(model));
};
exports.getAllLookmlModels = getAllLookmlModels;
const getAllExplores = async () => {
    const models = await (0, exports.getAllLookmlModels)();
    const explores = [];
    models.forEach((model) => {
        if (model.explores.length) {
            explores.push(...model.explores);
        }
    });
    return explores;
};
exports.getAllExplores = getAllExplores;
